export default "__VITE_ASSET__P3cKH11R__"